import React, { CSSProperties } from 'react';

import cn from 'classnames';

import styles from './PageOverlay.module.css';

type ContentProps = {
  [key: string]: any;
  children?: React.ReactNode;
  className?: string;
  height?: number | string;
  style?: CSSProperties;
  width?: number | string;
};

function Content({ width, height, className, style, children, ...passProps }: ContentProps) {
  const contentStyle = {
    width,
    height,
    ...style,
  };

  return (
    <div className={cn(styles.content, className)} style={contentStyle} {...passProps}>
      {children}
    </div>
  );
}

Content.displayName = 'Content';

export default Content;
